import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom';
import { PrivateRoute } from './components/PrivateRoute';
import RecordAudioPage from './components/RecordAudioPage';
import OnboardingWrapper from './onboarding/OnboardingWrapper';
import AccountDeletedPage from './pages/AccountDeletedPage';
import AuthCallback from './pages/AuthCallback';
import AuthPage from './pages/AuthPage';
import ChatPage from './pages/ChatPage';
import ClientPage from './pages/ClientPage';
import ClientsPage from './pages/ClientsPage';
import HomePage from './pages/HomePage';
import MeetingNotesPage from './pages/MeetingNotesPage';
import MeetingTemplatePage from './pages/MeetingTemplatePage';
import MeetingTemplatesPage from './pages/MeetingTemplatesPage';
import NotePage from './pages/NotePage';
import NotFoundPage from './pages/NotFoundPage';
import RecordAudioPageExistingMeeting from './pages/RecordAudioPageExistingMeeting';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SettingsPage from './pages/SettingsPage';
import TemplatePreviewPage from './pages/TemplatePreviewPage';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/record" element={<RecordAudioPage />} />
        {/* <Route path="/reports" element={<ReportsPage />} /> */}
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/chat/:meetingId" element={<ChatPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/clients/:clientId" element={<ClientPage />} />
        <Route path="/meeting-notes" element={<MeetingNotesPage />} />
        <Route
          path="/meeting-notes/:meetingId/record"
          element={<RecordAudioPageExistingMeeting />}
        />
        <Route path="/meeting-notes/:meetingId" element={<NotePage />} />
        {/* <Route path="/meeting-notes/1000" element={<NotePageHardcoded />} /> */}
        <Route path="/meeting-templates" element={<MeetingTemplatesPage />} />
        <Route path="/meeting-templates/new" element={<MeetingTemplatePage />} />
        <Route path="/meeting-templates/:templateId" element={<MeetingTemplatePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/onboarding" element={<OnboardingWrapper />} />
      </Route>
      <Route path="/login" element={<AuthPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/account-deleted" element={<AccountDeletedPage />} />
      <Route path="/templates/preview/:shareSlug" element={<TemplatePreviewPage />} />
      <Route path="*" element={<NotFoundPage />} /> {/* Catch all unmatched routes */}
    </>
  )
);

export default function App() {
  return <RouterProvider router={router} />;
}
